import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { AI_SPEND_CATEGORY_QUERY } from "@/apis/taxonomy/queries";
import { TAXONOMY_CLIENT } from "@/utils/consts";
import type { ExportFieldOption } from "../exportConfigurationFields";

type AiSpendCategoriesPayload = {
  spendAiCategory: {
    data: Array<{ id: string; name: string; exportName: string }>;
  };
};

/** AI Spend field options, sourced from the taxonomy as OppGen does. */
export const useAiSpendExportFields = (): {
  loading: boolean;
  fields: ExportFieldOption[];
} => {
  const { data, loading } = useQuery<AiSpendCategoriesPayload>(
    AI_SPEND_CATEGORY_QUERY,
    { context: { clientName: TAXONOMY_CLIENT } }
  );

  const fields = useMemo(
    () =>
      (data?.spendAiCategory?.data ?? []).map((category) => ({
        value: category.exportName,
        label: category.name,
      })),
    [data]
  );

  return { loading, fields };
};
